/* istanbul ignore file */

import axios from './axios';
import * as msg from 'utils/consts';
import { getToken, signOut } from 'services/auth';
import { ALERTA, USUARIO_LOGADO_FAS } from 'utils/consts';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';

axios.interceptors.response.use(response => {
  return response;
});

axios.interceptors.request.use(
  async config => {
    const token = JSON.parse(getToken());
    if (token) {
      config.headers.Authorization = `Bearer ${token.access_token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const interceptor = response => {
  console.info({ response });
  const status = response?.response?.status;

  if (status === 401) {
    fetchNotificationApp(msg.MSG_SESSAO_EXPIRADA, '', ALERTA.ERRO);
    sessionStorage.removeItem(USUARIO_LOGADO_FAS);
    signOut(null, true);
    return status;
  }
  if (status === 403) {
    fetchNotificationApp(msg.MSG_ERRO_PERMISSAO, '', ALERTA.ERRO);
    return status;
  }
  if (status === 502) {
    fetchNotificationApp(msg.MSG_ERRO_COMUNICACAO, '', ALERTA.ERRO);
    return status;
  }

  let mensagem = response?.response?.data?.errors;
  if (!mensagem) mensagem = response?.response?.data?.error;

  if (typeof mensagem === 'object') {
    const listObj = mensagem;
    Object.keys(listObj).forEach(key => {
      mensagem = listObj[key];
    });
  }

  if (!mensagem) mensagem = msg.MSG_ERRO_PADRAO;
  let title = '';
  if (status === 500) {
    title = 'Erro ao consultar servidor';
  }
  fetchNotificationApp(title, mensagem?.toString(), ALERTA.ERRO, null, null, response);

  return mensagem?.toString();
};
